import { TextField, SxProps } from "@mui/material";
import React from "react";

const ByteTextField = ({
  label,
  required,
  name,
  error,
  errorMessage,
  helperText,
  onChangeValue,
  type,
  ...rest
}: {
  required?: boolean;
  label: string;
  name?: string;
  sx: SxProps;
  error?: boolean;
  errorMessage?: string;
  helperText?: string;
  type?: string;
  onChangeValue?: (value: string) => void;
}) => {
  return (
    <TextField
      label={required ? `${label}*` : label}
      name={name ?? label}
      onChange={(e) => onChangeValue && onChangeValue(e.target.value)}
      type={type ?? "text"}
      error={error}
      FormHelperTextProps={{ sx: { mt: 1 } }}
      helperText={error ? errorMessage : helperText}
      {...rest}
    />
  );
};

export default ByteTextField;
